/* Native Shopify discount read model, shared by PDP and cart hints. */
(function () {
  'use strict';
  if (window.QuantityDiscountPreview) return;
  var refreshInterval = 60000, lastAttempt = 0, latestSchedule = 0;
  var snapshot = null, pending = null, timer = null, expiryTimer = null, listeners = [];

  function valid(data) {
    return data && data.version === 2 && data.source === 'shopify-flow' && Number.isFinite(data.scheduledAt) && Number.isFinite(data.expiresAt) &&
      data.scheduledAt <= Date.now() + 1000 && data.expiresAt > Date.now() &&
      data.scheduledAt > 0 && data.expiresAt > data.scheduledAt &&
      data.expiresAt <= data.scheduledAt + 1200000 && Array.isArray(data.rules) && data.rules.length < 100 &&
      data.rules.every(function (r) {
        return Number.isInteger(r.min) && r.min >= 2 && Number.isFinite(r.percent) && r.percent > 0 && r.percent <= 100 &&
          (r.collectionIds === null || (Array.isArray(r.collectionIds) && r.collectionIds.length > 0 && r.collectionIds.length < 100 &&
            r.collectionIds.every(function (id) { return /^gid:\/\/shopify\/Collection\/\d+$/.test(id); }))) &&
          Number.isInteger(r.recurringCycleLimit) && r.recurringCycleLimit >= 0 &&
          (r.endsAt === null || (Number.isFinite(r.endsAt) && r.endsAt >= data.expiresAt)) &&
          typeof r.appliesOnSubscription === 'boolean' && typeof r.appliesOnOneTimePurchase === 'boolean';
      });
  }
  function accept(data) {
    if (!valid(data) || data.scheduledAt < latestSchedule) { snapshot = null; return; }
    latestSchedule = data.scheduledAt;
    snapshot = data;
  }
  function seed() {
    var newest = null;
    document.querySelectorAll('[data-quantity-discount-snapshot]').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        if (valid(data) && (!newest || data.scheduledAt > newest.scheduledAt)) newest = data;
      } catch (_) { /* Missing data means no preview discount. */ }
    });
    if (newest) accept(newest);
  }
  function armExpiry() {
    clearTimeout(expiryTimer);
    if (snapshot) expiryTimer = setTimeout(function () { snapshot = null; notify(); }, Math.max(0, snapshot.expiresAt - Date.now()));
  }
  function current() { return snapshot && snapshot.expiresAt > Date.now() ? snapshot.rules : []; }
  function eligible(rule, ids) {
    return rule.collectionIds === null || rule.collectionIds.some(function (id) { return ids.indexOf(id) !== -1; });
  }
  function tiers(ids) {
    return current().filter(function (rule) { return eligible(rule, ids); });
  }
  function collectionLink(rule, el) {
    // Only Shopify collection paths, optionally localized, are navigable targets.
    var safePath = function (path) {
      return typeof path === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9][a-z0-9_-]*$/i.test(path);
    };
    if (rule.collectionIds === null) return safePath(el.dataset.allProductsUrl) ? el.dataset.allProductsUrl : null;
    var urls;
    try { urls = JSON.parse(el.dataset.collectionUrls); } catch (_) { return null; }
    if (!urls || typeof urls !== 'object' || Array.isArray(urls)) return null;
    for (var id of rule.collectionIds) {
      if (Object.prototype.hasOwnProperty.call(urls, id) && safePath(urls[id])) return urls[id];
    }
    return null;
  }
  function renderCartHints() {
    document.querySelectorAll('[data-cart-tier-hint]').forEach(function (el) {
      var items;
      try { items = JSON.parse(el.dataset.discountItems); } catch (_) { items = []; }
      var rules = current();
      var appliesTo = function (rule, item) {
        return (item.subscription ? rule.appliesOnSubscription : rule.appliesOnOneTimePurchase) && eligible(rule, item.collectionIds);
      };
      var counts = rules.map(function (rule) {
        return items.reduce(function (sum, item) { return sum + (appliesTo(rule, item) ? item.quantity : 0); }, 0);
      });
      var attained = items.map(function (item) {
        return rules.reduce(function (best, rule, index) {
          return counts[index] >= rule.min && appliesTo(rule, item) ? Math.max(best, rule.percent) : best;
        }, 0);
      });
      var next = rules.map(function (rule, index) {
        var improves = items.some(function (item, itemIndex) {
          return item.quantity > 0 && appliesTo(rule, item) && rule.percent > attained[itemIndex];
        });
        return { missing: counts[index] > 0 && improves ? rule.min - counts[index] : 0, percent: rule.percent, collectionIds: rule.collectionIds };
      }).filter(function (r) { return r.missing > 0; })
        .sort(function (a, b) { return a.missing - b.missing || b.percent - a.percent; })[0];
      el.hidden = !next;
      var text = el.querySelector('[data-cart-tier-text]');
      if (next) (text || el).textContent = el.dataset.text.replace('__COUNT__', next.missing).replace('__PERCENT__', next.percent);
      var link = el.querySelector('[data-cart-tier-link]');
      if (link) {
        var href = next ? collectionLink(next, el) : null;
        link.hidden = !href;
        if (href) link.setAttribute('href', href);
        else link.removeAttribute('href');
      }
    });
  }
  function notify() {
    listeners = listeners.filter(function (entry) { return entry.el.isConnected; });
    listeners.forEach(function (entry) { entry.callback(tiers(entry.ids)); });
    renderCartHints();
  }
  function refresh(force) {
    if (pending) return pending;
    var hasConsumers = document.querySelector('[data-native-quantity-discounts]') || listeners.some(function (entry) { return entry.el.isConnected; }) ||
      Array.prototype.some.call(document.querySelectorAll('[data-cart-tier-hint]'), function (el) {
        try { return JSON.parse(el.dataset.discountItems).length > 0; } catch (_) { return false; }
      });
    if (!hasConsumers) { clearTimeout(timer); clearTimeout(expiryTimer); snapshot = null; notify(); return Promise.resolve(); }
    if (document.hidden) { notify(); return Promise.resolve(); }
    if (!force && lastAttempt && Date.now() - lastAttempt < refreshInterval) {
      clearTimeout(timer);
      timer = setTimeout(function () { refresh(); }, refreshInterval - (Date.now() - lastAttempt));
      notify(); return Promise.resolve();
    }
    if (!snapshot || snapshot.expiresAt <= Date.now()) { snapshot = null; notify(); }
    clearTimeout(timer);
    lastAttempt = Date.now();
    var url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('section_id', 'quantity-discount-data');
    url.searchParams.set('_qd', String(lastAttempt));
    var abort = new AbortController();
    var timeout = setTimeout(function () { abort.abort(); }, 3500);
    pending = fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: abort.signal })
      .then(function (res) { if (!res.ok) throw new Error('Unavailable'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-quantity-discount-snapshot]');
        accept(el ? JSON.parse(el.textContent) : null);
      })
      .catch(function () { snapshot = null; })
      .then(function () {
        clearTimeout(timeout); pending = null; notify();
        armExpiry();
        timer = setTimeout(function () { refresh(); }, refreshInterval);
      });
    return pending;
  }
  seed();
  armExpiry();
  window.QuantityDiscountPreview = {
    subscribe: function (el, callback) {
      var ids;
      try { ids = JSON.parse(el.dataset.discountCollectionIds); } catch (_) { ids = []; }
      listeners.push({ el: el, ids: ids, callback: callback });
      callback(tiers(ids)); refresh();
    },
    refresh: refresh,
    renderCartHints: renderCartHints
  };
  document.addEventListener('visibilitychange', function () { clearTimeout(timer); if (!document.hidden) refresh(); });
  document.addEventListener('cart:updated', function () { refresh(); });
  document.addEventListener('shopify:section:load', function () { refresh(); });
  function init() { if (document.querySelector('[data-cart-tier-hint]')) refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
